import { serializeV2ListQuery } from './serialize-v2-list-query'
import { fetchWithSessionRecovery } from './v2-session-fetch'

/**
 * Opciones base para toda llamada al SDK de la API v2. Fuente única de verdad:
 * baseUrl derivada de la v1, cookies incluidas, `throwOnError`, el `fetch` que
 * renueva la sesión vencida y —crítico— el `querySerializer` con bracket notation
 * de los listados (el default del SDK rompe los filtros anidados del contrato
 * ADR 0020). Todo servicio v2 spreadea esto para no reimplementar —ni olvidar—
 * ninguna de esas piezas.
 */
const fallbackApiV2BaseUrl = import.meta.env.VITE_API_URL_NEST.replace(/\/api\/v1\/?$/, '')
const API_V2_BASE_URL = (import.meta.env.VITE_API_URL_V2 || fallbackApiV2BaseUrl).replace(/\/$/, '')

export const v2RequestOptions = {
  baseUrl: API_V2_BASE_URL,
  credentials: 'include' as const,
  throwOnError: true as const,
  /**
   * Renueva el access token y reintenta ante un 401 (ver `v2-session-fetch.ts`).
   *
   * Va acá —en las opciones que comparten los servicios de negocio— y NO como config global
   * del cliente hey-api, y esa es justamente la defensa contra la recursión:
   * `staff-session-v2.service.ts` declara sus propias opciones, así que las llamadas que
   * FORMAN la sesión (login, refresh, `/me`, legacy-access, logout) quedan afuera por
   * construcción. Si entraran, un 401 del refresh pediría un refresh: con la deduplicación
   * de `refreshV2Session` eso no es un bucle, es un deadlock —la promesa esperándose a sí
   * misma—. Excluirlas por diseño es más barato que acordarse de excluirlas por URL.
   */
  fetch: fetchWithSessionRecovery,
  querySerializer: serializeV2ListQuery
}

/** Cabecera Authorization con el Bearer de la sesión staff v2 (`auth.v2AccessToken`). */
export function bearer(accessToken: string) {
  return { Authorization: `Bearer ${accessToken}` }
}
